// BlogDashboard.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogPostList from "./BlogPostList";
import BlogApprovalQueue from "./BlogApprovalQueue";
import BlogStats from "./BlogStats";
import CommentModeration from "./CommentModeration";
import "./BlogDashboard.css";

const BlogDashboard = () => {
  const [activeTab, setActiveTab] = useState("posts");
  const navigate = useNavigate();

  return (
    <div className="blog-dashboard">
      <div className="blog-dashboard-header">
        <h1>Blog Management</h1>
        <button
          className="create-post-btn"
          onClick={() => navigate("/staff/blog/create")}
        >
          Create New Post
        </button>
      </div>

      <div className="blog-dashboard-tabs">
        <button
          className={`tab ${activeTab === "posts" ? "active" : ""}`}
          onClick={() => setActiveTab("posts")}
        >
          All Posts
        </button>
        <button
          className={`tab ${activeTab === "approval" ? "active" : ""}`}
          onClick={() => setActiveTab("approval")}
        >
          Approval Queue
        </button>
        <button
          className={`tab ${activeTab === "moderation" ? "active" : ""}`}
          onClick={() => setActiveTab("moderation")}
        >
          Comment Moderation
        </button>
        <button
          className={`tab ${activeTab === "stats" ? "active" : ""}`}
          onClick={() => setActiveTab("stats")}
        >
          Blog Statistics
        </button>
      </div>

      <div className="blog-dashboard-content">
        {activeTab === "posts" && <BlogPostList />}
        {activeTab === "approval" && <BlogApprovalQueue />}
        {activeTab === "moderation" && <CommentModeration />}
        {activeTab === "stats" && <BlogStats />}
      </div>
    </div>
  );
};

export default BlogDashboard;
